if(typeof dpt_team_card_controller == 'undefined'){
    var dpt_team_card_controller = {
        init: function(){
            jQuery('.team-card').on('click', function(){
                dpt_team_card_controller.open_modal(jQuery(this));
            });

            jQuery('.card-title a').on('click', function(e){
                e.stopPropagation();
            });

            jQuery('dialog.team-modal').each(function(){
                var $this = jQuery(this);
                $this.find('.close-modal').on('click', function(){
                    $this[0].close();
                });

                var $next = $this.next('.team-modal');

                if($next.length > 0)
                {
                    $this.find('.next-arrow').addClass('active').on('click', function(){
                        $this[0].close();
                        $next[0].showModal();
                    });
                }
                var $prev = $this.prev('.team-modal');
                if($prev.length > 0)
                {
                    $this.find('.prev-arrow').addClass('active').on('click', function(){
                        $this[0].close();
                        $prev[0].showModal();
                    });
                }
            });
        },
        open_modal: function($dom){
            var target = $dom.data('target');
            var $modal = jQuery(target);

            $modal[0].showModal();
        }
    };
    dpt_team_card_controller.init();

    jQuery(document).ready(function(){
        dpt_team_card_controller.init();
    });
}